
import { Component } from 'vue-property-decorator'
import ProductInsightsFilters from '@/modules/insight/components/ProductInsightsFilters.vue'
import ProductInsightsList from '@/modules/insight/components/ProductInsightsList.vue'
import VueStrong from '@/VueStrong'

@Component({ components: { ProductInsightsFilters, ProductInsightsList } })
export default class Insights extends VueStrong {}
